export const isEqual = (str1, str2) => {
	if (str1 && str2) {
		return str1.toLowerCase() === str2.toLowerCase();
	}
	return false;
};

export const doesContain = (haystack, needle) => {
	let classificationTest = false;
	if (haystack.toLowerCase() === 'all') {
		classificationTest = true;
	} else if (haystack && needle) {
		const haystackArray = haystack.split(',');
		haystackArray.forEach(str => {
			const stringToTest = str.trim();
			if (stringToTest.toLowerCase() === needle.toLowerCase()) {
				classificationTest = true;
			}
		});
	}
	return classificationTest;
};

export const getLegacyPopoverAttributes = btnAttributes => {
	const legacyAttributes = {};
	const popoverText = btnAttributes['data-content'] || false;
	const popoverTitle = btnAttributes['data-title'] || false;
	if (popoverText) {
		legacyAttributes.popoverText = popoverText;
		// eslint-disable-next-line no-param-reassign
		delete btnAttributes['data-content'];
	}
	if (popoverTitle) {
		legacyAttributes.popoverTitle = popoverTitle;
		// eslint-disable-next-line no-param-reassign
		delete btnAttributes['data-title'];
	}
	return legacyAttributes;
};



// WEBPACK FOOTER //
// ./src/utils/string-compare.js